import { showToast, router }  from "./utils.js"
import storage from "./storage.js";
import { appSystemInfo, isDev, isProd } from "@/app.config.js";

const $utils = {
	toast: showToast,
	storage,
	router,
	isDev,
	isProd,
	appSystemInfo
}

const install = (app, options) => {
	app.config.globalProperties.$utils = $utils;
	uni.$u = $utils;
}

export default {
	install
}